import {
  assignedByFilter,
  assignedToFilter,
  chatFilter,
  completedAtFilter,
  createdAtFilter,
  createdByFilter,
  deadlineFilter,
  isArchivedFilter,
  isCompletedFilter,
  lastMessageAtFilter,
  located,
  movedAtFilter,
  responsibleFilter,
  stickersFilter,
  stopwatchFilter,
  subtasksAssignedFilter,
  subtasksCompletedFilter,
  subtasksDeadlineFilter,
  subtasksFilter,
  textFilter,
  timerFilter,
  timetrackingFilter
} from './all-filters'

export const allFilters = [
  located,
  isCompletedFilter,
  isArchivedFilter,
  createdAtFilter,
  movedAtFilter,
  lastMessageAtFilter,
  completedAtFilter,
  createdByFilter,
  assignedByFilter,
  assignedToFilter,
  responsibleFilter,
  deadlineFilter,
  timetrackingFilter,
  timerFilter,
  stopwatchFilter,
  stickersFilter,
  subtasksFilter,
  subtasksDeadlineFilter,
  subtasksAssignedFilter,
  subtasksCompletedFilter,
  textFilter,
  chatFilter
]
